import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { FormGroup } from "react-bootstrap";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import Images from "assets/images/imageData";
import DatePicker from '../datePicker/datePicker';

const ContractRenewalFilter = ({
                             applyFilter,
                             contractTypes=[],
                             buckets=[],
                             cities = [],
                             contractStatus = [],
                             renewalStatus=[]
                         }) => {
    const filterInputs = {
        contract_status:"",
        contract_type:"",
        site_name:"",
        site_number:"",
        project_id:"",
        live_date:"",
        expiry_date:"",
        bucket:"",
        renewal_status:"",
        city_id:""
    };

    const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
    const [currentContractStatus,setCurrentContractStatus]=useState(null);
    const [currentContractType,setCurrentContractType]=useState(null);
    const [currentCityName,setCurrentCityName]=useState(null);
    const [currentRenewalStatus,setCurrentRewnewalStatus]=useState(null);

    useEffect(() => {
        (async () => {
            const filters = await JSON.parse(
                localStorage.getItem("applyFilter")
            );
            
            if (filters) {
                setFilterFieldsData(filters);
            }
        })();
    }, []);

    useEffect(() => {
        (async () => {
            setCurrentContractStatus(contractStatus.find(status => status.id === filterFieldsData.contract_status)?.name)
            setCurrentContractType(contractTypes.find(type => type.id === filterFieldsData.contract_type)?.name)
            setCurrentCityName(cities.find(city => city.id === filterFieldsData.city_id)?.name)
            setCurrentRewnewalStatus(renewalStatus.find(status => status.id === filterFieldsData.renewal_status)?.name)
        })();
    }, [filterFieldsData]);

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
                filterFieldsData && localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
            }}
        >
            <DropDownInput
                label={'Contract Status'}
                data={contractStatus}
                getIdValue={(val) =>{
                    setFilterFieldsData({
                        ...filterFieldsData,
                        contract_status: val.id,
                    })
                }
                }
                value={currentContractStatus}
            />
            <DropDownInput
                label={'Renewal Status'}
                data={renewalStatus}
                getIdValue={(val) =>{
                    setFilterFieldsData({
                        ...filterFieldsData,
                        renewal_status: val.id,
                    })
                }
                }
                value={currentRenewalStatus}
            />
            <DropDownInput
                label={'Contract Types'}
                data={contractTypes}
                getIdValue={(val) =>{
                    setFilterFieldsData({
                        ...filterFieldsData,
                        contract_type: val.id,
                    })
                }
                }
                value={currentContractType}
            />
            <ConstantInput
                label={localization.siteName}
                value={filterFieldsData && filterFieldsData.site_name}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, site_name: val });
                }}
            />
            <ConstantInput
                label={localization.siteNumber}
                value={filterFieldsData && filterFieldsData.site_number}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, site_number: val });
                }}
            />
            <ConstantInput
                label={localization.projectId}
                value={filterFieldsData && filterFieldsData.project_id}
                type="text"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, project_id: val });
                }}
            />
            <DatePicker
                handleChange={(val) =>
                    setFilterFieldsData({ ...filterFieldsData, live_from_date: val })
                }
                label={'Live from Date'}
                required={false}
                value={filterFieldsData && filterFieldsData.live_from_date}
            />
            <DatePicker
                handleChange={(val) =>
                    setFilterFieldsData({ ...filterFieldsData, live_to_date: val })
                }
                label={'Live to Date'}
                required={false}
                value={filterFieldsData && filterFieldsData.live_to_date}
            />
            <DatePicker
                handleChange={(val) =>
                    setFilterFieldsData({ ...filterFieldsData, expiry_from_date: val })
                }
                label={'Expiry from Date'}
                required={false}
                value={filterFieldsData && filterFieldsData.expiry_from_date}
            />
            <DatePicker
                handleChange={(val) =>
                    setFilterFieldsData({ ...filterFieldsData, expiry_to_date: val })
                }
                label={'Expiry to Date'}
                required={false}
                value={filterFieldsData && filterFieldsData.expiry_to_date}
            />
            <DropDownInput
                label={'Expiring In (Days)'}
                data={buckets}
                getIdValue={(val) =>{
                    setFilterFieldsData({
                        ...filterFieldsData,
                        bucket: val.id,
                    })
                }
                }
                value={filterFieldsData.bucket||''}
            />
            <DropDownInput
                label={localization.city}
                data={cities}
                getIdValue={(val) =>{
                    setFilterFieldsData({
                        ...filterFieldsData,
                        city_id: val.id,
                    })
                }
                }
                value={currentCityName}
            />

            <br />
            <br />
            <br />

            <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                    {localization.applyFilter}
                    <img src={Images?.ArrowRight} alt="" />
                </button>
                <br/>
                <br/>
                <button
                    onClick={() => {
                        localStorage.setItem("applyFilter", JSON.stringify(filterInputs));
                        applyFilter(filterInputs);
                        localStorage.setItem("statusFilter", JSON.stringify({}));
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.removeFilter}
                </button>
            </div>
        </form>
    );
};

export default ContractRenewalFilter;
